import { useQuery } from "@tanstack/react-query";
import AppContext from "PFApp/app_context";
import { useSession } from "PFApp/use_session";
import { QueryOptions } from "PFTypes/request_options";
import { useContext } from "react";

import { fetchSkillsBarData } from "../../../services/insights/skills_bar_api";
import { queryKeys } from "./query_keys";

export type BarData = {
  category_1: string;
  num_developmental_profiles: number;
  num_profiles: number;
  num_rare_profiles: number;
  num_roles: number;
  num_top_profiles: number;
};

type BarMessage = {
  message: string;
};

export type SimpleData = {
  label: string;
  value: string;
};

export type SkillsBarData = {
  bar: BarData[] | BarMessage;
  dropdown: SimpleData[];
  skills: SimpleData[];
};

type UseSkillsBarQuery = {
  params: Record<string, any>;
};

export const useSkillsBarQuery = ({ params }: UseSkillsBarQuery, options?: QueryOptions<SkillsBarData>) => {
  const session = useSession();
  const {
    store: { currentAccount }
  } = useContext(AppContext);
  return useQuery<SkillsBarData>(
    queryKeys.skillsBar(params),
    async () => await fetchSkillsBarData(session.getAccessToken(), currentAccount.full_domain, params),
    options
  );
};
